import { injectable } from "tsyringe";
import { makeAutoObservable } from "mobx";

export const TOKEN_GlobalMenuStore = Symbol("GlobalMenuStore");

@injectable()
export default class GlobalMenuStore {
    private _isOpen: boolean = false;
    private _lastCloseTime: number = 0;
    private _cooldownPeriod: number = 300; // 300ms cooldown
    private _recentClosePeriod: number = 500; // Time window to consider "just closed"

    constructor() {
        makeAutoObservable(this);
    }

    get isOpen(): boolean {
        return this._isOpen;
    }

    get isJustClosed(): boolean {
        return !this._isOpen &&
            this._lastCloseTime > 0 &&
            Date.now() - this._lastCloseTime < this._recentClosePeriod;
    }

    onOpenChange = (open: boolean): void => {
        if (open && this.isInCooldown()) {
            return; // Don't open if in cooldown period
        }

        this._isOpen = open;

        if (!open) {
            this._lastCloseTime = Date.now();
        }
    };

    toggleOpen = (): void => {
        if (!this._isOpen || !this.isInCooldown()) {
            this._isOpen = !this._isOpen;

            if (!this._isOpen) {
                this._lastCloseTime = Date.now();
            }
        }
    };

    close = (): void => {
        if (this._isOpen) {
            this._isOpen = false;
            this._lastCloseTime = Date.now();
        }
    };

    private isInCooldown(): boolean {
        return Date.now() - this._lastCloseTime < this._cooldownPeriod;
    }
}